import { createTheme } from '@mui/material/styles';

export const colors: Record<string, string> = {
  primary: '#245d38',
  secondary: '#292b2c',
  modalBackdropColor: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.66), rgba(0, 0, 0, 0.66))',
};

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 481,
      md: 721,
      lg: 1081,
      xl: 1201,
    },
  },
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
  },
  typography: {
    fontFamily: [
      'Open Sans',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  components: {
    MuiButton: {
      defaultProps: {
        sx: {
          borderRadius: 0,
          padding: '6px 10px',
        },
      },
    },
    MuiSvgIcon: {
      variants: [
        {
          props: { color: 'success' },
          style: {
            color: colors.primary,
          },
        },
      ],
    },
  },
});
